import axios from "axios";
//getEmployeeBioData
import {
	TRAVEL_LOADING,
	TRAVEL_SAVING_FAILED,
	TRAVEL_SAVING_SUCCESSED,
} from "./types";
export const getEmployeeTravelData = (listdata) => (dispatch) => {
	dispatch({ type: TRAVEL_LOADING });

	let formData = new FormData(); //formdata object
	console.log("loadNotifications data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({ type: TRAVEL_SAVING_SUCCESSED, payload: response });

			console.log("loadNotifications=", response);
		})
		.catch((error) => {
			console.log(error);
			return dispatch({
				type: TRAVEL_SAVING_FAILED,
				payload: error,
			});
		});
};
